module.exports = __webpack_public_path__ + "img/robot2.3cf2e1e8.png";